import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'reportController';
export default {
    /**
     * 回款统计报表
     */
    getAllRepaymentReportData: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllRepaymentReportData',
        type: requestType.Get
    },
    /**
     * 每日催收统计
     */
    queryCollectDataDays: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryCollectDataDays',
        type: requestType.Get
    }
};
